// extracted by mini-css-extract-plugin
export default {"select":"ControlledSelect_select__r8qOG","formGroupText":"ControlledSelect_formGroupText__GO7Fx"};